import useSWRImmutable from 'swr/immutable';
import {
  getVisitorDataRequest,
  getVisitorDataResponse,
} from '@core-api/browser-settings/visitor-data';
import {
  getCountryFromLocalStorage,
  DEFAULT_COUNTRY,
  setCountryInLocalStorage,
} from './country';

type BrandedString = string & {};

export interface VisitorData {
  country: BrandedString | typeof DEFAULT_COUNTRY;
}

export interface UserVisitorDataResult {
  visitorData: VisitorData | null;
  isLoading: boolean;
}

const VISITOR_DATA_CACHE_KEY = 'visitor-data';

export function useVisitorData(): UserVisitorDataResult {
  const { data, isLoading } = useSWRImmutable(
    VISITOR_DATA_CACHE_KEY,
    getVisitorDataWithFallback,
  );

  return { visitorData: data ?? null, isLoading };
}

export async function getVisitorDataWithFallback(): Promise<VisitorData> {
  const country = getCountryFromLocalStorage();

  if (country) {
    return {
      country,
    };
  }

  const data = await fetchVisitorData();

  return data;
}

async function fetchVisitorData(): Promise<VisitorData> {
  const request = getVisitorDataRequest({
    region: 'eu',
  });
  const response = await fetch(request);
  const data = await getVisitorDataResponse(response, {
    enableStatusCheck: false,
  });

  return data;
}

export function getVisitorDataCache(): VisitorData {
  const country: VisitorData['country'] =
    getCountryFromLocalStorage() ?? DEFAULT_COUNTRY;

  return {
    country,
  };
}

export function setVisitorDataCache(data: Partial<VisitorData>): void {
  if (data.country) {
    setCountryInLocalStorage(data.country);
  }
}
